<template>
    <div>
        <section v-if="!initialLoading">
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table
                            id="data-table-list-courses"
                            class="table table-hover-animation table-striped table-bordered"
                        >
                            <caption>
                                Lista de cursos IPSSOMA
                            </caption>
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Curso</th>
                                    <th scope="col">Precio</th>
                                    <th scope="col">Fecha de registro</th>
                                    <th scope="col">Meses</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(course, index) in this.courses"
                                    v-bind:key="index"
                                >
                                    <td>
                                        <p style="width: 15px">
                                            {{ course.id }}
                                        </p>
                                    </td>
                                    <td>
                                        <p style="width: 220px">
                                            {{ course.nombre }}
                                        </p>
                                    </td>
                                    <td>S/. {{ course.precio }}</td>
                                    <td>{{ course.created_at }}</td>
                                    <td>{{ course.months }}</td>
                                    <td>
                                        <el-tag
                                            v-if="
                                                course.estado_publicacion == 1
                                            "
                                            class="ml-2"
                                            type="success"
                                            effect="dark"
                                            round
                                            >Activo</el-tag
                                        >
                                        <el-tag
                                            effect="dark"
                                            round
                                            v-else
                                            class="ml-2"
                                            type="warning"
                                            >Inactivo</el-tag
                                        >
                                    </td>

                                    <td class="align-content-center">
                                        <el-select
                                            v-model="optionSelected"
                                            @change="getOptionSelected(course)"
                                            clearable
                                            :remote-show-suffix="false"
                                            clear-icon
                                            id="customize_select"
                                        >
                                            <template
                                                v-if="this.user.roles_id == 6"
                                            >
                                                <el-option
                                                    v-for="item in options2"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                />
                                            </template>
                                            <template v-else>
                                                <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                />
                                            </template>
                                        </el-select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <custom-spinner v-else></custom-spinner>

        <custom-modal
            id="edit-course-modal"
            color="primary"
            size="extralarge"
            v-if="courseSelected"
        >
            <template #title
                >Editar curso <u> {{ courseSelected.title }} </u></template
            >
            <template #body>
                <form-course-edit
                    :course="courseSelected"
                    :categoriesList="categories"
                ></form-course-edit>
            </template>
        </custom-modal>

        <custom-modal id="delete-course-modal" color="danger">
            <template #title
                >Borrar curso <u> {{ courseSelected.title }} </u></template
            >
            <template #body>¿Seguro que desea eliminar este curso?</template>
            <template #footer>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="closeModal('delete-course-modal')"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteCourse(courseSelected.id)"
                >
                    Eliminar
                </button>
            </template>
        </custom-modal>
    </div>
</template>
<script>
import ModalComponent from "../ModalComponent.vue";
import CourseEdit from "./CoursesEdit.vue";
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            initialLoading: false,
            courses: [],
            categories: [],
            levels: [],
            options2: [
                {
                    value: "5",
                    label: "Exámenes",
                },
            ],
            options: [
                {
                    value: "1",
                    label: "Módulos y clases",
                },
                {
                    value: "2",
                    label: "Editar",
                },
                {
                    value: "3",
                    label: "Publicar/Despublicar",
                },
                {
                    value: "4",
                    label: "Eliminar",
                },
                {
                    value: "5",
                    label: "Exámenes",
                },
                {
                    value: "6",
                    label: "Pre-visualizar",
                },
                {
                    value: "7",
                    label: "Lista de alumnos",
                },
            ],
            optionSelected: "",
            courseSelected: {},
            url: "http://ipssoma.com/redirect/",
            //url: 'http://127.0.0.1:8080/redirect/',
        };
    },
    components: {
        "custom-modal": ModalComponent,
        "form-course-edit": CourseEdit,
        "custom-spinner": CustomSpinner,
    },

    mounted() {
        this.listCourses();
        this.listCategories();
    },

    methods: {
        closeModal(id) {
            $(`#${id}`).modal("hide");
        },
        loadDataTable() {
            $(document).ready(function () {
                $("#data-table-list-courses").DataTable(language);
            });
        },
        listCourses: function () {
            this.initialLoading = true;
            axios.get(`/productos/list`).then((response) => {
                this.courses = response.data;
                this.initialLoading = false;
                this.loadDataTable();
            });
        },
        listCategories() {
            axios
                .get(`/productos/tipo-producto`)
                .then((response) => {
                    if (response.data.error) {
                        this.message = "Sin categorias registradas";
                    } else {
                        Object.keys(response.data).map((key) => {
                            this.categories.push(response.data[key]);
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async deleteCourse(course_id) {
            const { data } = await axios.delete(`/course/delete/${course_id}`);
            if (data.status == "ok") {
                this.$message.success(
                    "Se ha movido a la papelera correctamente"
                );
                this.listCourses();
                this.optionSelected = "";
            }
            $("#delete-course-modal").modal("hide");
        },

        /**
         * Return data about the option selected in the table
         * @param {object} course - The course object selected
         */
        getOptionSelected(course) {
            
            let option = this.optionSelected;
            switch (option) {
                case "1":
                    document.location.href = `/productos/module/${course.id}/editModule`;
                    break;
                case "2":
                    this.courseSelected = course;
                    $("#edit-course-modal").modal("show");
                    this.optionSelected = "";
                    break;
                case "3":
                    this.toggleStatus(course);
                    break;

                case "4":
                    this.courseSelected = course;
                    $("#delete-course-modal").modal("show");
                    this.optionSelected = "";
                    break;
                case "5":
                    document.location.href = `/productos/exam/${course.id}/create`;
                    break;
                case "6":
                    this.preview(course);
                    break;
                case "7":
                    window.location.href = `/course/${course.id}/users`;
                    break;
                default:
                    console.log("Error");
                    break;
            }
        },
        async preview(course) {
            await axios
                .get(`/preview?slug_product=${course.slug}`)
                .then((response) => {
                    window.open(`${this.url}${response.data}`, "_blank");
                    this.optionSelected = "";
                });
        },
        async toggleStatus(course) {
            try {
                const url = `/course/toggle-status/${course.id}`;
                const { data } = await axios.put(url);
                if (data.status == "ok") {
                    this.$message.success(
                        "Se ha actualizado el estado del curso"
                    );
                    this.listCourses();
                    this.optionSelected = "";
                }
            } catch (error) {
                alert(error);
            }
        },

        /**
         * 0 -> registrado e inactivo
         * 1 -> en espera
         * 2 -> activo
         */
        // async sendRequest(id) {
        //     const data = await axios.post(`/course/${id}/sendRequest`);

        //     switch (data.data) {
        //         case "ok":
        //             this.$message.success(
        //                 "Curso enviado a revisión correctamente"
        //             );
        //             break;
        //         case "request":
        //             this.$message.warning(
        //                 "Ya se ha enviado el curso para su revisión"
        //             );
        //             break;
        //         case "empty":
        //             this.$message.warning(
        //                 "El curso debe tener al menos un módulo y una clase"
        //             );
        //             break;
        //         case "misconfigured":
        //             this.$message.warning(
        //                 "Configure la entrega del certificado"
        //             );
        //             break;
        //         case "signaturetemplate":
        //             this.$message.warning(
        //                 "Seleccione la plantilla y firma para el certificado"
        //             );
        //             break;
        //         default:
        //             this.$message.warning("Error al validar datos");
        //             break;
        //     }
        //     this.listCourses();
        // },
    },
};
</script>
<style>
.el-icon {
    width: 20px;
}
.el-select .el-input .el-select__caret::before {
    display: none !important;
}
.el-icon .el-select__caret .el-select__icon {
    transform: rotateZ(0deg);
}
#customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
}
</style>
